export default __webpack_public_path__ + "images/instapay.dfba7149400130c137621db75f284784.jpeg";